import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import api from "../lib/api";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired"); return;
        }
        if (tries > 30) {
          setStatus("timeout"); return;
        }
        setTries((t) => t + 1);
        timer = setTimeout(poll, 2000);
      } catch {
        if (tries > 30) { setStatus("error"); return; }
        setTries((t) => t + 1);
        timer = setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; clearTimeout(timer); };
  // eslint-disable-next-line
  }, [sessionId, tries]);

  return (
    <div className="min-h-screen bg-ivory grid place-items-center p-4" data-testid="billing-success-page">
      <div className="w-full max-w-md card-base p-8 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="mx-auto text-sage-500 animate-spin" size={32} />
            <h1 className="font-heading text-2xl font-semibold mt-4">Confirming payment…</h1>
            <p className="text-sm text-ink-600 mt-2">Hang tight — this usually takes a few seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="mx-auto w-12 h-12 rounded-full bg-sage-100 text-sage-600 grid place-items-center"><Check size={28} /></div>
            <h1 className="font-heading text-2xl font-semibold mt-4">You're on Platinum 🎉</h1>
            <p className="text-sm text-ink-600 mt-2">Everything's unlocked. You can manage your subscription from your Profile.</p>
            <button onClick={() => navigate("/diary")} className="btn-primary w-full justify-center mt-6" data-testid="billing-continue-btn">Open AMDS</button>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <h1 className="font-heading text-2xl font-semibold">Couldn't confirm payment</h1>
            <p className="text-sm text-ink-600 mt-2">If you were charged, your status will update shortly. Otherwise try again.</p>
            <button onClick={() => navigate("/pricing")} className="btn-secondary w-full justify-center mt-6">Back to pricing</button>
          </>
        )}
      </div>
    </div>
  );
}
